module.exports = __webpack_public_path__ + "img/thumbnail_Nyala_m_albino.f347880c.png";